import axios from "axios";

// Auto-upgrade http:// → https:// when the page is served over HTTPS (S3/CloudFront).
// Browser blocks mixed-content (HTTP requests from HTTPS pages) which causes 404-like failures.
function upgradeUrl(url) {
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return url.replace(/^http:\/\//i, "https://");
  }
  return url;
}

export const LAWYER_API_BASE = upgradeUrl(
  process.env.REACT_APP_LAWYER_API_URL || process.env.REACT_APP_API_URL || "http://localhost:5000/api"
);
export const USER_API_BASE = upgradeUrl(
  process.env.REACT_APP_USER_API_URL || process.env.REACT_APP_API_URL || "http://localhost:5000/api"
);


const TOKEN_KEY = "lawyerAuthToken";
const USER_KEY = "lawyerUser";

function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

function attachInterceptors(instance, label, { clearOn401 = true } = {}) {
  instance.interceptors.request.use((config) => {
    const token = getToken();
    console.log('[AXIOS][' + label + ']', config.method?.toUpperCase(), config.baseURL + config.url, 'token:', token ? 'present' : 'MISSING');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (clearOn401 && error?.response?.status === 401) {
        clearSession();
      }
      return Promise.reject(error);
    }
  );
}

export const lawyerApi = axios.create({
  baseURL: LAWYER_API_BASE,
  timeout: 15000,
});

export const userApi = axios.create({
  baseURL: USER_API_BASE,
  timeout: 20000,
});

attachInterceptors(lawyerApi, 'lawyerApi', { clearOn401: true });
attachInterceptors(userApi,   'userApi',   { clearOn401: false });

export const sessionStorage = {
  TOKEN_KEY,
  USER_KEY,
  getToken,
  clearSession,
};
